/* eslint-disable import/prefer-default-export,import/no-unresolved,react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MAIN_ICON_COLORS } from 'assets/components';
import { Tooltip } from 'react-tooltip';
import { PromoLogo } from '../PromoLogo';
import Icon from '../../../../components/Icon';
import { ICONS } from '../../../../components/Icon/constants';
import { getCurrentLanguage, switchLanguage } from '../../../../i18n';

export const PromoHeader = () => {
  const { t: translate } = useTranslation();
  const history = useHistory();

  const tooltipRef = useRef(null);
  const langBtnRef = useRef(null);
  const headerRef = useRef(null);

  const [showLanguageSelector, setShowLanguageSelector] = React.useState(false);

  const [selectedLang, setSelectedLang] = useState('en');

  useEffect(() => {
    const currentLang = getCurrentLanguage();
    setSelectedLang(currentLang);
  }, []);

  const availableLangs = useMemo(
    () => [
      {
        value: 'en',
        label: 'lang_name_en',
      },
      {
        value: 'de',
        label: 'lang_name_de',
      },
    ],
    []
  );

  const handleClickOutside = (e) => {
    if (
      tooltipRef.current &&
      !tooltipRef.current.contains(e.target) &&
      langBtnRef.current &&
      !langBtnRef.current.contains(e.target) &&
      headerRef.current &&
      !headerRef.current.contains(e.target)
    ) {
      setShowLanguageSelector(false);
      document.removeEventListener('mousemove', handleClickOutside);
    }
  };

  useEffect(() => () => document.removeEventListener('mousemove', handleClickOutside), []);

  const handleOpenLanguageSelector = () => {
    setShowLanguageSelector(true);
    document.addEventListener('mousemove', handleClickOutside);
  };

  return (
    <div
      className=" flex-row justify-content-between d-flex w-100"
      ref={headerRef}
      style={{
        paddingTop: '2.5rem',
        paddingBottom: '2rem',
      }}>
      <PromoLogo />
      <div className="d-flex justify-content-end" style={{ gap: '1rem' }}>
        <button
          onClick={() => history.push('/onboarding/login')}
          className="btn-primary-outline d-flex align-items-center gap-3"
          style={{ height: '40px' }}
          type="button">
          {translate('login_form_button_label')}
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ width: '12px', height: '12px' }}>
            <Icon icon={ICONS.RIGHT_ARROW} color={MAIN_ICON_COLORS.WHITE} />
          </div>
        </button>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <button
          ref={langBtnRef}
          data-tooltip-id="language-selector"
          type="button"
          className="btn-primary-outline px-2"
          style={{ width: '40px', height: '40px', outline: 'none', zIndex: 20 }}
          onMouseEnter={() => {
            handleOpenLanguageSelector();
          }}>
          <Icon icon={ICONS.GLOBE_LANG} color={MAIN_ICON_COLORS.WHITE} />
        </button>
      </div>
      <Tooltip
        id="language-selector"
        isOpen={showLanguageSelector}
        place="bottom"
        variant="dark"
        opacity={1}
        style={{ zIndex: 20, padding: '0px', pointerEvents: 'auto' }}
        className="d-none d-md-block rounded border-1">
        <ul ref={tooltipRef} className="d-flex flex-column list-unstyled m-0">
          {availableLangs.map((lang) => (
            <li
              role="presentation"
              tabIndex={-1}
              onKeyDown={null}
              onClick={() => {
                setSelectedLang(lang.value);
                switchLanguage(lang.value);
                setShowLanguageSelector(false);
              }}
              className={`cursor-pointer px-5 py-2 ${
                selectedLang === lang.value ? 'text-primary' : 'text-hover'
              }`}
              key={lang.value}>
              {translate(lang.label)}
            </li>
          ))}
        </ul>
      </Tooltip>
    </div>
  );
};
